<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'invoicebook.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateInvoiceBook"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'invoicebook.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteInvoiceBook"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['invoiceBook'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },

    methods: {
      async deleteInvoiceBook() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('invoiceBook/delete', this.invoiceBook.id);
          this.$store.dispatch('invoiceBook/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateInvoiceBook() {
        this.$router.push('/sales/invoice-books/update/' + this.invoiceBook.id);
      }
    }
  };
</script>
